import { FC } from 'react'

import { useAtomValue } from 'jotai'
import { AnimatePresence, motion } from 'framer-motion'
import { match } from 'ts-pattern'

import { GreyWhite } from '@sequencehq/core-components'

import { currentSidebarModeAtom } from 'Automations/automationEditor/atoms'
import { VersionHistory } from './modes'

export const Sidebar: FC = () => {
  const mode = useAtomValue(currentSidebarModeAtom)

  return (
    <AnimatePresence>
      {mode && (
        <motion.div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            backgroundColor: GreyWhite,
            overflowX: 'hidden',
            overflowY: 'auto',
            borderLeft: 'rgba(0, 0, 0, 0.08) 1px solid',
            flexShrink: '0'
          }}
          initial={{ width: '0px' }}
          animate={{ width: '320px' }}
          exit={{ width: '0px' }}
          transition={{ duration: 0.2 }}
        >
          {match(mode)
            .with('VERSION_HISTORY', () => <VersionHistory />)
            .exhaustive()}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
